import axios from "axios"
import { ProductInitialValueType } from "../components/products/AddProduct"
import { UpdateProductPayloadType } from "../components/products/Product"

const REACT_APP_HOST = process.env.REACT_APP_HOST

const getStatsURL = `${REACT_APP_HOST}/api/stats`
const getProductsURL = `${REACT_APP_HOST}/api/products`
const getMenClothingURL = `${REACT_APP_HOST}/api/men/clothing`
const getMenShoesURL = `${REACT_APP_HOST}/api/men/shoes`
const getMenAccessoriesURL = `${REACT_APP_HOST}/api/men/accessories`
const getMenUnderwearsURL = `${REACT_APP_HOST}/api/men/underwears`
const getWomenClothingURL = `${REACT_APP_HOST}/api/women/clothing`
const getWomenShoesURL = `${REACT_APP_HOST}/api/women/shoes`
const getWomenAccessoriesURL = `${REACT_APP_HOST}/api/women/accessories`
const getWomenUnderwearsURL = `${REACT_APP_HOST}/api/women/underwears`
const getToysURL = `${REACT_APP_HOST}/api/kids/toys`
const getKidsPinkURL = `${REACT_APP_HOST}/api/kids/pink`
const getKidsBlueURL = `${REACT_APP_HOST}/api/kids/blue`

const getStats = async (token: string) => {
  const config = {
    headers: { Authorization: token }
  }
  const res = await axios.get(getStatsURL, config)
  
  return res.data
}

const getProduct = async (id: string | number) => {
  const getProductURL = `${REACT_APP_HOST}/api/products/${id}`

  const res = await axios.get(getProductURL)
  return res.data
}

const getProducts = async () => {
  const res = await axios.get(getProductsURL)
  return res.data
}

const getMenClothing = async () => {
  const res = await axios.get(getMenClothingURL)
  return res.data
}

const getMenShoes = async () => {
  const res = await axios.get(getMenShoesURL)
  return res.data
}

const getMenAccessories = async () => {
  const res = await axios.get(getMenAccessoriesURL)
  return res.data
}

const getMenUnderwears = async () => {
  const res = await axios.get(getMenUnderwearsURL)
  return res.data
}

const getWomenClothing = async () => {
  const res = await axios.get(getWomenClothingURL)
  return res.data
}

const getWomenShoes = async () => {
  const res = await axios.get(getWomenShoesURL)
  return res.data
}

const getWomenAccessories = async () => {
  const res = await axios.get(getWomenAccessoriesURL)
  return res.data
}

const getWomenUnderwears = async () => {
  const res = await axios.get(getWomenUnderwearsURL)
  return res.data
}

const getToys = async () => {
  const res = await axios.get(getToysURL)
  return res.data
}

const getKidsPink = async () => {
  const res = await axios.get(getKidsPinkURL)
  return res.data
}

const getKidsBlue = async () => {
  const res = await axios.get(getKidsBlueURL)
  return res.data
}

const addKidsBlue = async (
  token: string, 
  payload: ProductInitialValueType
) => {
  const url = `${REACT_APP_HOST}/api/kids/blue`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.post(url, payload, config);

  return res.data;
}

const addKidsPink = async (
  token: string,
  payload: ProductInitialValueType
) => {
  const url = `${REACT_APP_HOST}/api/kids/pink`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.post(url, payload, config);

  return res.data;
}

const addMenAccessories = async (
  token: string,
  payload: ProductInitialValueType
) => {
  const url = `${REACT_APP_HOST}/api/men/accessories`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.post(url, payload, config);

  return res.data;
}

const addMenClothing = async (
  token: string,
  payload: ProductInitialValueType
) => {
  const url = `${REACT_APP_HOST}/api/men/clothing`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.post(url, payload, config);

  return res.data;
}

const addMenShoes = async (
  token: string,
  payload: ProductInitialValueType
) => {
  const url = `${REACT_APP_HOST}/api/men/shoes`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.post(url, payload, config);

  return res.data;
}

const addMenUnderwear = async (
  token: string,
  payload: ProductInitialValueType
) => {
  const url = `${REACT_APP_HOST}/api/men/underwears`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.post(url, payload, config);

  return res.data;
}

const addWomenAccessories = async (
  token: string,
  payload: ProductInitialValueType
) => {
  const url = `${REACT_APP_HOST}/api/women/accessories`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.post(url, payload, config);

  return res.data;
}

const addWomenClothing = async (
  token: string,
  payload: ProductInitialValueType
) => {
  const url = `${REACT_APP_HOST}/api/women/clothing`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.post(url, payload, config);

  return res.data;
}

const addWomenShoes = async (
  token: string,
  payload: ProductInitialValueType
) => {
  const url = `${REACT_APP_HOST}/api/women/shoes`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.post(url, payload, config);

  return res.data;
}

const addWomenUnderwear = async (
  token: string,
  payload: ProductInitialValueType
) => {
  const url = `${REACT_APP_HOST}/api/women/underwears`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.post(url, payload, config);

  return res.data;
}

const addKidsToys = async (
  token: string,
  payload: ProductInitialValueType
) => {
  const url = `${REACT_APP_HOST}/api/kids/toys`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.post(url, payload, config);

  return res.data;
}

const updateProduct = async (
  id: string,
  token: string,
  payload: UpdateProductPayloadType
) => {
  const url = `${REACT_APP_HOST}/api/products/${id}`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.put(url, payload, config);

  return res.data;
}

const deleteProduct = async (
  id: string,
  token: string,
) => {
  const url = `${REACT_APP_HOST}/api/products/${id}`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.delete(url, config);

  return res.data;
}

export {
  deleteProduct,
  updateProduct,
  addKidsToys,
  addWomenAccessories,
  addWomenUnderwear,
  addWomenShoes,
  addWomenClothing,
  addMenUnderwear,
  addMenShoes,
  addMenClothing,
  getStats,
  getProduct,
  getProducts,
  getMenClothing,
  getMenShoes,
  getMenAccessories,
  getMenUnderwears,
  getWomenClothing,
  getWomenShoes,
  getWomenAccessories,
  getWomenUnderwears,
  getToys,
  getKidsPink,
  getKidsBlue,
  addKidsBlue,
  addKidsPink,
  addMenAccessories
}